import React from 'react';
// import PropTypes from 'prop-types';

import {
  Paper,
  Stack,
  Typography,
  Box,
  Button,
  Container,
  Card,
  CardContent,
} from 'views/components';
import {Translate} from 'views/module';
import {ArrowForward, Schedule, Favorite, People} from 'views/icons';

import {useNavigate} from 'react-router-dom';

const CaregiverApplicationLanding = () => {
  const navigate = useNavigate();

  const handleStartApplication = () => {
    navigate('/caregiver-application/form');
  };

  return (
    <Box sx={{background: 'linear-gradient(180deg,rgba(252, 246, 239, 1) 0%, rgba(255, 255, 255, 1) 100%)'}}>
      <Container maxWidth="md" sx={{py: 4}} >
        <Paper elevation={3} sx={{p: 4, borderRadius: 2}}>
          <Stack spacing={4} alignItems="center">
            {/* Header Section */}
            <Box textAlign="center">
              <Box sx={{mb: 2}}>
                <img
                  src="/logo/quilt-icon.png"
                  alt="CareQuilt Logo"
                  width="60"
                  height="60"
                  style={{display: 'block', margin: '0 auto'}}
                />
              </Box>
              <Typography variant="h3" component="h1" gutterBottom>
                <Translate expression="caregiverScreening.Landing.Title" />
              </Typography>
              <Typography variant="h6" color="text.secondary" sx={{maxWidth: 600}}>
                <Translate expression="caregiverScreening.Landing.Subtitle" />
              </Typography>
            </Box>

            {/* Benefits Cards */}
            <Stack
              direction={{xs: 'column', md: 'row'}}
              spacing={3}
              sx={{width: '100%', mt: 4}}
            >
              <Card sx={{flex: 1}}>
                <CardContent sx={{textAlign: 'center', p: 3}}>
                  <Schedule sx={{fontSize: 40, color: 'primary.main', mb: 2}} />
                  <Typography variant="h6" gutterBottom>
                    <Translate expression="caregiverScreening.Landing.FlexibleWork" />
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    <Translate expression="caregiverScreening.Landing.FlexibleWorkDesc" />
                  </Typography>
                </CardContent>
              </Card>

              <Card sx={{flex: 1}}>
                <CardContent sx={{textAlign: 'center', p: 3}}>
                  <Favorite sx={{fontSize: 40, color: 'primary.main', mb: 2}} />
                  <Typography variant="h6" gutterBottom>
                    <Translate expression="caregiverScreening.Landing.MeaningfulWork" />
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    <Translate expression="caregiverScreening.Landing.MeaningfulWorkDesc" />
                  </Typography>
                </CardContent>
              </Card>

              <Card sx={{flex: 1}}>
                <CardContent sx={{textAlign: 'center', p: 3}}>
                  <People sx={{fontSize: 40, color: 'primary.main', mb: 2}} />
                  <Typography variant="h6" gutterBottom>
                    <Translate expression="caregiverScreening.Landing.Community" />
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    <Translate expression="caregiverScreening.Landing.CommunityDesc" />
                  </Typography>
                </CardContent>
              </Card>
            </Stack>

            {/* Application Process Overview */}
            <Box sx={{textAlign: 'center', mt: 4}}>
              <Typography variant="h5" gutterBottom>
                <Translate expression="caregiverScreening.Landing.ProcessTitle" />
              </Typography>
              <Typography variant="body1" color="text.secondary" sx={{mb: 3}}>
                <Translate expression="caregiverScreening.Landing.ProcessDesc" />
              </Typography>
              {/* Call to Action Button */}
              <Button
                variant="contained"
                size="large"
                onClick={handleStartApplication}
                endIcon={<ArrowForward />}
                sx={{
                  'px': 4,
                  'py': 2,
                  'fontSize': '1.1rem',
                  'borderRadius': 2,
                  'boxShadow': 3,
                  '&:hover': {
                    'boxShadow': 6,
                  },
                }}
              >
                <Translate expression="caregiverScreening.Landing.StartApplication" />
              </Button>
            </Box>


            {/* Additional Info */}
            <Typography variant="body2" color="text.secondary" sx={{textAlign: 'center'}}>
              <Translate expression="caregiverScreening.Landing.TimeEstimate" />
            </Typography>
          </Stack>
        </Paper>
      </Container>
    </Box>
  );
};

export default CaregiverApplicationLanding;
